import ProductListWithControls from './ProductListWithControls'

export default ProductListWithControls